import React, {useContext, useEffect, useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {AuthContext} from "../../../config/AuthContext";
import {useNavigate, useParams} from "react-router-dom";
import NavBar from "../../components/NavBar";
import Login from "../../root/Login";
import {Alert, Button, Card, DatePicker, Form, Input, InputNumber, Popover, Table, Tag, Popconfirm, Select} from "antd";
import Colors from "../../../styles/Colors";
import {BiEuro, BiFilter, BiInfoCircle, BiPencil, BiPlus, BiReceipt, BiRefresh, BiSearch, BiFile } from "react-icons/bi";
import {InfoCircleOutlined} from "@ant-design/icons";
import Historials from "../../components/Historials";
import {ColumnsType, TableProps} from "antd/es/table";
import {BsEye, BsPlusCircle, BsReceiptCutoff} from "react-icons/bs";
import {GetRebuts} from "../../../dao/multilleure/administracio/GetRebuts";
import Rebut from "../../../model/multilleure/rebuts/Rebut";
import RebutModal from "./components/RebutModal";
import RebutLista from "./components/RebutLista";
import RebutFIltre from "../../../model/multilleure/rebuts/RebutFIltre";
import dayjs, {Dayjs} from 'dayjs';
import Contacte from "../../../model/multilleure/gestioinscripcions/Contacte";
import {GetContactes} from "../../../dao/multilleure/gestioinscripcions/GetContactes";
import {PostRemesa} from "../../../dao/multilleure/administracio/PostRemesa";
import toast, {Toaster} from "react-hot-toast";
import InscripcionsContactesModal from "./components/InscripcionsContactesModal";
import RebutGrupModal from "./components/RebutGrupModal";
import FacturaModal from './components/ResguardModal';
import RebutFraccionarModal from './components/RebutFracionarModal';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import {GetActivitatsJson} from "../../../dao/multilleure/GetActivitatsJson";
import Activitat from '../../../model/inscripcions/Activitat';

const Rebuts = () => {
    const titol: string = "REBUTS";

    const {isLoggedIn, userId, user, page} = useContext(AuthContext);
    const navigate = useNavigate();
    const {dni} = useParams();
    

    const [coleccio, setDades] = useState<Rebut[]>([]);
    const [elementSelected, setElementSelected] = useState<Rebut>();
    const [contactes, setContactes] = useState<Contacte[]>();
    const [activitats, setActivitats] = useState<Activitat[]>();
    const [loading, setLoading] = useState(false);
    const [nouElement, setNouElement] = useState(false);
    const [nouGrupElement, setNouGrupElement] = useState(false);
    const [visible, setVisible] = useState(true);
    const [nomFiltres, setNomFiltres] = useState<{ text: string; value: string }[]>([]);
    const [showFilters, setShowFilters] = useState(false);
    const [rebutFiltre, setRebutFiltre] = useState<RebutFIltre>(new RebutFIltre());
    const [selected, setSelected] = useState<Rebut[]>([]);
    const [rebutModal, setRebutModal] = useState(false);
    const [facturaModal, setfacturaModal] = useState(false);
    const [fracionarModal, setFraccionarModal] = useState(false);
    const [dadesFiltrades, setDadesFiltrades] = useState<Rebut[]>(coleccio);

    const [total, setTotal] = useState(0.00);
    const [numRebuts, setNumRebuts] = useState(0);
    const {RangePicker} = DatePicker;
    const moment = require('moment');

    useEffect(() => {
        handleLoadingChange(true)
        if (isLoggedIn) {
            checkDades();
        }
    }, [dni]);

    async function checkDades() {
        if (dni != undefined) {
            console.log("Filtres " + rebutFiltre.any + " " + rebutFiltre.idRebut);
            const newFiltre = {...rebutFiltre, idContacte: dni};
            setRebutFiltre(newFiltre);
            handleLoadingChange(true)
            const dades = await GetRebuts(page, newFiltre);
            const contactes = await GetContactes(page);
            const activitats = await GetActivitatsJson(page);
            setActivitats(activitats);
            setDades(dades);
            setContactes(contactes);
            await setNameFilters(dades);
            await handleLoadingChange(false);
            setDadesFiltrades(dades);
            
        } else {
            console.log("Filtres " + rebutFiltre.any + " " + rebutFiltre.idRebut);
            handleLoadingChange(true)
            const dades = await GetRebuts(page, rebutFiltre);
            const contactes = await GetContactes(page);
            const activitats = await GetActivitatsJson(page);
            setActivitats(activitats);
            setDades(dades);
            setContactes(contactes);
            await setNameFilters(dades);
            await handleLoadingChange(false);
            setDadesFiltrades(dades);
        }
    }

    function toggleTable() {
        setVisible(!visible);
    }
    
    function getActivitatNameById(id: number): string {
        const found = activitats?.find(act => act.id === id);
        return found ? found.nom : "Desconegut";
    }

    async function getDataMapeado() {
        const mappedData = await Promise.all(dadesFiltrades.map(async (item) => ({
            "ID": item.id,
            "Quota": item.quota,
            "Id remesa": item.remesa,
            "Preu": item.preu,
            "Estat": item.estat,
            "Pagament": item.pagament,
            "Alta": item.alta,
            "Modificació": item.modificacio,
            "Concepte": item.concepte,
            "IBAN": item.iban,
            "Pagador": item.pagador,
            "Activitat": item.id_activitat != null ? getActivitatNameById(item.id_activitat) : "Desconegut",
            "Observacions": item.observacions,
            "Pagat": item.pagat,
        })));

        return mappedData;
    }

    const exportToExcel = (data: any[], fileName = "rebuts.xlsx") => {
        if (!Array.isArray(data) || data.length === 0) {
            console.warn("No hay datos válidos para exportar");
            return;
        }

        const worksheet = XLSX.utils.json_to_sheet(data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Rebuts");

        const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array",
        });

        const blob = new Blob([excelBuffer], {
            type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
        });

        saveAs(blob, fileName);
    };

    async function crearRebut(element: Rebut) {
        setElementSelected(element);
        setfacturaModal(true);
        //await DeleteRebut(id, page);
        await checkDades();
    }

    function afegirElement(element: Rebut) {
        setNouElement(!nouElement);
        setElementSelected(element);
    }

    function togleNouElement(element: Rebut) {
        setNouElement(!nouElement);
        setElementSelected(element);
    }
    function handleCloseModalFactura(refresh: boolean) {
         setfacturaModal(false);
    }


    function handleCloseModal(refresh: boolean) {
        if (refresh){
            checkDades();
            toast.success("GUARDAT");
        }
        else
            toast.error("NO GUARDAT");
        setNouElement(false);
        setRebutModal(false);
        setNouGrupElement(false);
        setFraccionarModal(false);
       
    }

    const handleLoadingChange = (enable: boolean) => {
        setLoading(enable);
    };

    function setNameFilters(elements: Rebut[]) {
        if (elements?.length > 0) {
            const uniqueNonEmptyNames = Array.from(new Set(elements
                .map((element) => element.pagador)
                .filter((name) => name !== '')));

            const ingredientNames = uniqueNonEmptyNames.map((name) => ({
                text: name,
                value: name,
            }));

            setNomFiltres(ingredientNames);
        }
    }

    function veureRebut(ele: any) {
        setElementSelected(ele);
        setRebutModal(true);
    }
    
    function veureFracionar(ele: any) {
        const hasNonZeroRemesa = ele.remesa !== "0";
        const hasFraccionat = Boolean(ele.fraccionat);
        if (hasNonZeroRemesa || hasFraccionat) {
            if(hasNonZeroRemesa){
                toast.error("Aquest rebut ja ha sigut facturat. No es pot fraccionar");
            }
            if (hasFraccionat){
                toast.error("Aquest rebut ja forma part d'una fraccionació. No es pot fraccionar.");
            }
            
        } else {
            setElementSelected(ele);
            setFraccionarModal(true);
        }
        
    }

    const columns: ColumnsType<Rebut> = [
        {
            key: 'id',
            title: 'ID',
            dataIndex: 'id',
            defaultSortOrder: 'descend',
            width: 5,
            responsive: ['lg'],
            sorter: (a, b) => a.id - b.id,
        },
        //Nom del nen
        {
            key: 'pagador',
            title: 'Pagador',
            dataIndex: 'pagador',
            width: 100,
            responsive: ['lg'],
        },
        {
            key: 'pagament',
            title: 'pagament',
            dataIndex: 'pagament',
            width: 20,
            render: (_, {pagament}) => (
                <>
                    {pagament === "RD" &&
                        <Tag color={"green"}>
                            {pagament}
                        </Tag>
                    }
                    {pagament === "TR" &&
                        <Tag color={"blue"}>
                            {pagament}
                        </Tag>
                    }
                    {pagament === "EF" &&
                        <Tag color={"red"}>
                            {pagament}
                        </Tag>
                    }
                    {pagament === "TG" &&
                        <Tag color={"orange"}>
                            {pagament}
                        </Tag>
                    }
                </>
            ),
            filterSearch: true,
            filters: [
                {
                    text: 'RD',
                    value: 'RD',
                },
                {
                    text: 'TR',
                    value: 'TR',
                },
                {
                    text: 'EF',
                    value: 'EF',
                },
                {
                    text: 'TG',
                    value: 'TG',
                },
            ],
            onFilter: (value, record) =>
                (record.pagament === value),
        },
        {
            key: 'estat',
            title: 'estat',
            dataIndex: 'estat',
            width: 1,
            render: (_, {estat}) => (
                <>
                    {estat === "pagat" &&
                        <Tag color={"green"}>
                            {estat}
                        </Tag>
                    }
                    {estat === "pendent" &&
                        <Tag color={"orange"}>
                            {estat}
                        </Tag>
                    }
                    {estat === "anulat" &&
                        <Tag color={"gray"}>
                            {estat}
                        </Tag>
                    }
                    {estat === "retornat" &&
                        <Tag color={"red"}>
                            {estat}
                        </Tag>
                    }
                </>
            ),
            filterSearch: true,
            filters: [
                {
                    text: 'Pagat',
                    value: 'pagat',
                },
                {
                    text: 'Pendent',
                    value: 'pendent',
                },
                {
                    text: 'Retornat',
                    value: 'retornat',
                },
                {
                    text: 'Anulat',
                    value: 'anulat',
                },
            ],
            onFilter: (value, record) =>
                (record.estat === value),
        },
        {
            key: 'concepte',
            title: 'concepte',
            dataIndex: 'concepte',
            responsive: ['lg'],
            width: 150,
            render: (estat, ele) => (
                <div dangerouslySetInnerHTML={{__html: ele.concepte}}/>
            ),
        },
        {
            key: 'preu',
            title: 'Pagat / Preu',
            dataIndex: 'preu',
            width: 150,
            render: (_, {preu, pagat}) => (
                <>
                    <Tag color={(pagat !== preu ? "red" : "green")}>
                        {pagat}
                    </Tag> / {"  "}
                    <Tag color={(pagat !== preu ? "orange" : "green")}>
                        {preu}
                    </Tag>
                </>
            ),
            filterSearch: true,
            filters: [
                {
                    text: 'Pagat',
                    value: 'pagat',
                },
                {
                    text: 'Pendent pagament',
                    value: 'pendent pagament',
                },
            ],
            onFilter: (value, record) =>
                ((record.preu !== record.pagat ? "pendent pagament" : "pagat") === value),

        },
        {
            key: 'accions',
            title: 'Accions',
            dataIndex: 'accions',
            width: 200,
            render: (estat, ele) => (
                <>
                    <Button title={"Editar"} style={{backgroundColor: Colors.colors.color6}}
                            onClick={() => togleNouElement(ele)}><BiPencil/></Button>
                    {" "}
                    <Button title={"Descarregar resguard"} style={{backgroundColor: Colors.colors.color5}} 
                            onClick={() => crearRebut(ele)}><BiReceipt/></Button>
                    {" "}
                    <Button title={"Veure Insripcions"} style={{backgroundColor: Colors.colors.color4}}
                            onClick={() => veureRebut(ele)}
                    ><BsEye/></Button>
                    {" "}
                    <Button title={"Fraccionar Rebut"} style={{backgroundColor: Colors.colors.color3}} onClick={() => veureFracionar(ele)}
                    ><BsReceiptCutoff/></Button>
                </>
            ),
        },
    ];

    const tableProps: TableProps<Rebut> = {
        loading
    };

    const onChange: TableProps<Rebut>['onChange'] =
        (pagination,
         filters,
         sorter,
         extra) => {
            //console.log('params', pagination, filters, sorter, extra);
        };

    const expandedRowRender2 = (ele: Rebut) => {
        return (
            <RebutLista element={ele}/>
        );
    };

    function submit() {
        //console.log("Contenido de rebutFiltre:", JSON.stringify(rebutFiltre, null, 2));
        checkDades();
    }

    const handleNumberInput = (newIdRebut: number | null, attributeName: string) => {
        const idRebut = newIdRebut || 0;
        setRebutFiltre((prevRebutFiltre) => ({
            ...prevRebutFiltre,
            [attributeName]: idRebut,
        }));
    };

    const handleStringInput = (event: React.ChangeEvent<HTMLInputElement>, attributeName: string) => {
        const value = event.target.value || "";  // Usar una cadena vacía si el valor es nulo
        setRebutFiltre((prevRebutFiltre) => ({
            ...prevRebutFiltre,
            [attributeName]: value,
        }));
    };

    type RangeValue = [Dayjs | null, Dayjs | null] | null;
    const handleDateRangeInput = (dates: RangeValue, dateStrings: [string, string]) => {
        const startDate = dates?.[0]?.format("DD/MM/YYYY") || "";
        const endDate = dates?.[1]?.format("DD/MM/YYYY") || "";

        setRebutFiltre((prevRebutFiltre) => ({
            ...prevRebutFiltre,
            dataInici: startDate,
            dataFi: endDate,
        }));
    };

    const handleDateInput = (value: Dayjs | null, attributeName: string, format: string) => {
        const date = value && value.format(format) || "";

        setRebutFiltre((prevRebutFiltre) => ({
            ...prevRebutFiltre,
            [attributeName]: date,
        }));
    };

    const activitatOptions = activitats?.map(act => ({
        label: act.nom,
        value: act.id, // esto es lo que se enviará al estado
    }));

    function changeTotal(selectedRows: Rebut[]) {
        //console.log(selectedRows);
        let tarifa = 0.0;
        let total = 0;
        selectedRows.forEach((value) => {
            tarifa += parseFloat(value.preu + "");
            total++;
            //tarifa += parseFloat((value.preu * (value.quota/100)) + "");
        });
        const hasNonZeroRemesa = selectedRows.some((value) => value.remesa !== "0");
        if (hasNonZeroRemesa) {
            toast.error("Un o més rebuts ja han sigut facturats. No es pot generar una remesa d'aquests");
            setTotal(0.00);
            setNumRebuts(0);
        } else {
            setTotal(parseFloat(tarifa.toFixed(2)));
            setNumRebuts(total);
        }
    }

    const rowSelection = {
        onChange: (selectedRowKeys: React.Key[], selectedRows: Rebut[]) => {
            changeTotal(selectedRows);
            setSelected(selectedRows);
        }
    };


    async function generarRemesa() {
        //console.log(selected);
        console.log(">>" + JSON.stringify({rebuts: selected}));
        let response = await PostRemesa(selected, page, userId);
        checkDades();
        
        toast.success("S'ha generat la remesa");
        setTimeout(() => {
        navigate(`/artsiesports/remeses`);
        }, 1000);
        
        
    }

    const content = (
        <div>
            <p>1) Aplica els <b>filtres</b> genèrics <Button title={"Mostrar Filtres"}
                                                             style={{backgroundColor: Colors.colors.color5}}><BiFilter/></Button> o
                específics des de la taula.</p>
            <p>2) <b>Marca els rebuts</b> que vols facturar.</p>
            <p><p style={{color: "red"}}><b>IMPORTANT!</b></p> Has de marcar <b>página per página</b> tots els rebuts.
            </p>
            <p>3) <b>Prem el botó</b> <Button title={"Generar Remesa"}
                                              style={{backgroundColor: Colors.colors.color5}}>GENERAR REMESA&nbsp;
                <BiEuro/></Button></p>
            <p>4) Automàticament es redirigeix a la pantalla de <b>Remeses</b> on es pot descarregar la remesa.</p>
        </div>
    );

    function afegirGrupsRebuts() {
        setNouGrupElement(true);
    }

    if (isLoggedIn) {
        return (
            <div>
                <Toaster/>
                <NavBar/>
                <div className={"general"}>
                    <Card bordered={true} className={"elemento"}>
                        <div className={"actionButtons"}>
                            <Popover content={
                                <div>
                                    <p>Crea un nou Rebut des de zero.</p>
                                </div>
                            } title="Crear un Nou Rebut">
                                <Button title={"Nou Rebut"} style={{backgroundColor: Colors.colors.color1}}
                                        onClick={() =>
                                            afegirElement(new Rebut)}><BiPlus/></Button>
                            </Popover>
                            <Popover content={
                                <div>
                                    <p>Crear un conjunts de Rebuts (per exemple, Tibidabo, samarretes, etc.)</p>
                                </div>
                            } title="Crear un conjunts de Rebuts">
                                <Button title={"Nou Grup de Rebuts"} style={{backgroundColor: Colors.colors.color2}}
                                        onClick={afegirGrupsRebuts}><BsPlusCircle/></Button>
                            </Popover>
                            <Popover content={
                                <div>
                                    <p>Torna a carregar el contingut de la taula, es mantenen els filtres.</p>
                                </div>
                            } title="Torna a carregar el contingut de la taula">
                                <Button title={"Tornar a carregar"} style={{backgroundColor: Colors.colors.color4}}
                                        onClick={() =>
                                            checkDades()}><BiRefresh/></Button>
                            </Popover>
                            <Popover content={
                                <div>
                                    <p>Mostra els filtres per poder aplicar al contingut dels rebuts.</p>
                                </div>
                            } title="Mostrar els Filtres dels rebuts">
                                <Button title={"Mostrar Filtres"} style={{backgroundColor: Colors.colors.color5}}
                                        onClick={() =>
                                            setShowFilters(!showFilters)}><BiFilter/></Button>
                            </Popover>
                            <Popover content={content} title="Passos a seguir per generar una Remesa">
                                <Button title={"Mostrar Filtres"}
                                        style={{backgroundColor: Colors.colors.color6}}><BiInfoCircle/></Button>
                            </Popover>
                        </div>
                        {showFilters && (
                            <>
                                <br/>
                                <br/>
                                <br/>
                                <Form
                                    name="complex-form"
                                    onFinish={() => console.log("FINISH")}
                                    style={{maxWidth: 'none'}}
                                >
                                    <Form.Item style={{marginBottom: 0}}>
                                        <Form.Item
                                            name="year"
                                            style={{display: 'inline-block', width: 'calc(24% - 8px)'}}
                                        >
                                            <DatePicker picker={"year"} style={{width: "100%"}}
                                                        defaultValue={dayjs(rebutFiltre.any, "YYYY")}
                                                        onChange={(value) => handleDateInput(value, "any", "YYYY")}
                                                        placeholder="Any dels rebuts"/>
                                        </Form.Item>
                                        <Form.Item
                                            name="idRebut"
                                            style={{display: 'inline-block', width: 'calc(24% - 8px)', margin: '0 8px'}}
                                        >
                                            <InputNumber style={{width: "100%"}} placeholder="número de Rebut" min={1}
                                                         onChange={(value: number | null) => handleNumberInput(value, "idRebut")}/>
                                        </Form.Item>
                                        <Form.Item
                                            name="idremesa"
                                            style={{display: 'inline-block', width: 'calc(24% - 8px)', margin: '0 8px'}}
                                        >
                                            <InputNumber style={{width: "100%"}} placeholder="número de remesa" min={1}
                                                         onChange={(value: number | null) => handleNumberInput(value, "idRemesa")}/>
                                        </Form.Item>
                                        <Form.Item
                                            name="pagador"
                                            style={{display: 'inline-block', width: 'calc(24% - 8px)', margin: '0 8px'}}
                                        >
                                            <Input style={{width: "100%"}} placeholder="Nom Pagador"
                                                   onChange={(value) => handleStringInput(value, "nomPagador")}/>
                                        </Form.Item>
                                    </Form.Item>
                                    <Form.Item style={{marginBottom: 0}}>
                                        <Form.Item
                                            name="infant"
                                            style={{display: 'inline-block', width: 'calc(24% - 8px)'}}
                                        >
                                            <Input style={{width: "100%"}} placeholder="Nom Infant"
                                                   onChange={(value) => handleStringInput(value, "nomInfant")}/>
                                        </Form.Item>
                                        <Form.Item
                                            name="activitat"
                                            style={{display: 'inline-block', width: 'calc(24% - 8px)', margin: '0 8px'}}
                                        >
                                            <Select
                                                showSearch
                                                placeholder="Activitat"
                                                optionFilterProp="children"
                                                filterOption={(input, option) =>
                                                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                                }
                                                options={activitatOptions}
                                                onChange={(value) => handleNumberInput(value, "activitat")}
                                                allowClear
                                            />

                                        </Form.Item>
                                        <Form.Item
                                            name="dates"
                                            style={{display: 'inline-block', width: 'calc(41% - 8px)', margin: '0 8px'}}
                                        >
                                            <RangePicker style={{width: "100%"}}
                                                         placeholder={["rebuts de la data", "fins la data"]}
                                                         format="DD/MM/YYYY"
                                                //onChange={(value: RangeValue, dateStrings) => handleDateRangeInput(value, ["dataInici", "dataFi"])}
                                                        onChange={handleDateRangeInput}
                                            />
                                            
                                        </Form.Item>
                                        <Form.Item label={"  "}
                                                   name="button"
                                                   style={{display: 'inline-block', width: 'calc(10% - 8px)'}}
                                        >
                                            <Button title="Buscar" style={{backgroundColor: Colors.colors.color6}}
                                                    onClick={() => submit()}><BiSearch/></Button>
                                            {" "} 

                                            <Popover content={
                                                <div>
                                                    <p>Només es descarregaran les files que apareixen a la taula. <br /> Pots aplicar filtres genèrics o específics des de la taula abans de descarregar.</p>
                                                </div>
                                            } title="Descarrega en format Excel.">
                                                <Button title={"Exportar a Excel"} style={{backgroundColor: Colors.colors.color5}}
                                                        onClick={ async() =>{
                                                            const data = await getDataMapeado();
                                                            exportToExcel(data);}}><BiFile/></Button>
                                            </Popover>
                                        </Form.Item>
                                        
                                    </Form.Item>
                                </Form>
                            </>
                        )}
                        <h4 className={"titol"}>{titol}</h4>
                        <br/>
                        <Alert type={"success"}
                               message={"Sel·lecciona els rebuts que vols facturar per generar la Remesa"}/>
                        <br/>
                        <p>Preu total: <b>{parseFloat(total.toFixed(2))} eur</b></p>
                        <p>Número de Rebuts: <b>{numRebuts}</b></p>
                        {parseFloat(total.toFixed(2)) > 0.00 &&
                            <Button title={"Generar Remesa"} style={{backgroundColor: Colors.colors.color5}}
                                    onClick={generarRemesa}>GENERAR REMESA&nbsp;<BiEuro/></Button>}
                        {visible && (
                            <Table
                                {...tableProps}
                                //onChange={onChange}
                                columns={columns}
                                pagination={{position: ["topCenter"]}}
                                expandable={{
                                    expandedRowRender: (record) =>
                                        expandedRowRender2(record),
                                    rowExpandable: (record) => true,

                                }}
                                dataSource={coleccio}
                                rowSelection={{
                                    type: 'checkbox',
                                    ...rowSelection,
                                }}
                                onChange={(pagination, filters, sorter, extra) => {
                                    setDadesFiltrades(extra.currentDataSource); // guarda solo lo visible
                                }}

                            />
                        )}
                    </Card>
                    <br/>
                    <Historials pantalla={"rebuts"} pagina={page}/>
                    {nouElement && (
                        <RebutModal element={elementSelected} onClose={handleCloseModal} visible={nouElement}
                                    handleSubmit={() => console.log("submit")} checkData={checkDades}
                                    contactes={contactes}
                        />
                    )}
                    {nouGrupElement && (
                        <RebutGrupModal onClose={handleCloseModal} visible={nouGrupElement} />
                    )}
                    {rebutModal && (
                        <InscripcionsContactesModal element={elementSelected} onClose={handleCloseModal} visible={rebutModal} />
                    )}
                    {facturaModal && (
                        <FacturaModal element={elementSelected} onClose={handleCloseModalFactura} visible={facturaModal} />
                    )}
                    {fracionarModal && (
                        <RebutFraccionarModal element={elementSelected} onClose={handleCloseModal} visible={fracionarModal} />
                    )}
                </div>
            </div>
        );
    } else {
        return (
            <Login/>
        );
    }
};
export default Rebuts;
